export default __webpack_public_path__ + "static/media/548.a057d523.gif";